module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-section clearfix"
  }, [(_vm.jumpList.length > 1) ? _c('label', {
    staticClass: "kp-modular-label"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.all_other_cases')))]) : _c('label', {
    staticClass: "kp-modular-label"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.always_jump_to')))]), _vm._v(" "), _c('step-jump-select', {
    attrs: {
      "jump": _vm.jump,
      "selected": _vm.selected
    }
  })], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-5f31d63f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/jump/selects/Exception.vue
 ** module id = 843
 ** module chunks = 1
 **/